import React from "react";
import { Outlet } from "react-router-dom";
import Grid from "@mui/material/Grid";
import AssetListPanel from "./AssetListPanel";

const TaskCreateEdit = (props) => {
  return (
    <Grid container>
      <Grid item xs={7} sx={{}}>
        <Outlet></Outlet>
      </Grid>
      <AssetListPanel></AssetListPanel>
    </Grid>
  );
};

export default TaskCreateEdit;
